export default {
    mySubscriptionsInitial: false
}


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/MySubscriptions/state.js